export default __webpack_public_path__ + "static/media/AdrianaCisneros.0b1f1d05.jpeg";